import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/menuIcons/person-plus.svg'


const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "main-m font-m" }
const _hoisted_9 = {
  key: 1,
  class: "row w-full mtop-10"
}
const _hoisted_10 = { class: "col-0-8 colend mright-04" }
const _hoisted_11 = { class: "main-m font-m" }
const _hoisted_12 = {
  key: 0,
  class: "main-alert"
}
const _hoisted_13 = { class: "col w-full" }
const _hoisted_14 = { class: "col w-full" }
const _hoisted_15 = { class: "row w-full mtop-10" }
const _hoisted_16 = { class: "col-0-8 colend mright-04" }
const _hoisted_17 = { class: "main-m font-m" }
const _hoisted_18 = { class: "col w-full" }
const _hoisted_19 = { class: "row w-full mtop-10" }
const _hoisted_20 = { class: "col-0-8 colend mright-04" }
const _hoisted_21 = { class: "main-m font-m" }
const _hoisted_22 = { class: "col w-full" }
const _hoisted_23 = { class: "row w-full mtop-10" }
const _hoisted_24 = { class: "col-0-8 colend mright-04" }
const _hoisted_25 = { class: "main-m font-m" }
const _hoisted_26 = { class: "flex gap-30 row" }
const _hoisted_27 = ["for"]
const _hoisted_28 = { class: "row w-full mtop-10" }
const _hoisted_29 = { class: "col-0-8 colend mright-04" }
const _hoisted_30 = { class: "main-m font-m" }
const _hoisted_31 = { class: "colend mleft-04 mright-04" }
const _hoisted_32 = { class: "main-m font-m" }
const _hoisted_33 = { class: "row w-full mtop-10" }
const _hoisted_34 = { class: "col-0-8 colend mright-04" }
const _hoisted_35 = { class: "main-m font-m" }
const _hoisted_36 = { class: "mtop-10" }
const _hoisted_37 = { class: "row w-full mtop-10" }
const _hoisted_38 = { class: "col-0-8 colend mright-04" }
const _hoisted_39 = { class: "main-m font-m" }
const _hoisted_40 = { class: "row w-full mtop-10" }
const _hoisted_41 = { class: "col-0-8 colend mright-04" }
const _hoisted_42 = { class: "main-m font-m" }
const _hoisted_43 = { class: "col-0-6 colend mright-04 mleft-04" }
const _hoisted_44 = { class: "main-m font-m" }
const _hoisted_45 = { class: "row w-full mtop-10" }
const _hoisted_46 = { class: "col-0-8 colend mright-04" }
const _hoisted_47 = { class: "main-m font-m" }

import { ref, computed, onMounted, watch } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import { parse } from "date-fns";
import { ApiError, ButtonAction, DateFormat, IsoCode, Gender, ItemButtonGroup, ItemSelect, ItemSelectPhone } from '@/models/share.model';
import { CreatePatientRequest, PatientApi, SearchPatientResponse } from '@/apiGenerate/medserver';
import { COUNTRY_LIST, PHONE_PREFIX_LIST } from '@/functions/geo';
import { format } from "date-fns";
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError, toastSuccess, toastWarn } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import RadioButton from 'primevue/radiobutton';
import EsSelectCountry from '@/components/esSelectCountry.vue';
import Message from 'primevue/message';
import { convertToFormattedBirthdate } from '@/utils/ssn-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'addPatientForm',
  props: {
  newId: {
    type: String,
    required: true,
  },
  newIdFormatted: {
    type: String,
    required: true,
  },
  fastPatientCreation: {
    type: Boolean,
    default: false,
  },
  clipboardText: {
    type: String,
    required: false,
  },  
},
  emits: ['afterPatientCreated', 'redirectCalendar'],
  setup(__props, { emit: __emit }) {

const props = __props;

const appUserStore = useAppUserStore()
const { t } = useI18n();
const toast = useToast();

const patientApi = new PatientApi(medServerApiConfig);

const genderOptions = ref<string[]>(Object.values(Gender) as string[]);

const countries = ref<ItemSelect[]>([]);
const phoneCountries = ref<ItemSelect[]>([]);

const errorForm = ref<boolean>(false);

const itemButtonGroup = ref<ItemButtonGroup[]>([
  {
    icon: 'stethoscope',
    codeAction: 'REDIRECT_FOLDER',
    pathIcon: 'shareIcons',
    method: async () => await confirmFormModal(ButtonAction.REDIRECT_FOLDER)
  }
]);

const createPatientRequest = ref<CreatePatientRequest>({
  firstname: undefined,
  lastname: undefined,
  mail: undefined,
  // birthdate: props.newId && props.newId.length == 8? format(parseISO(props.newId), DateFormat.FRONT_LONG) : undefined,
  birthdate: convertToFormattedBirthdate(props.newId),
  gender: undefined,
  serialNumber: props.newIdFormatted ?? undefined,
  address: {
    street: undefined,
    postalCode: undefined,
    locality: undefined,
    isoCode: undefined
  },
  phone: {
    phoneNumber: undefined,
    phonePrefix: undefined,
    mobile: false
  }
})

const emits = __emit;

const countryToItemSelect = (country: {isoCode: string; term: string}): ItemSelect => {
  return {
    id: country.isoCode,
    label: country.term,
  }
}

const getCountries = () => {
  countries.value = COUNTRY_LIST.map((country: {isoCode: string; term: string}) => {
    return countryToItemSelect(country);
  });
}

const phoneCountryToItemSelect = (phone: {prefix: string, isoCode: string; term: string}): ItemSelectPhone => {
  return {
    id: phone.isoCode,
    label: `${phone.term}`,
    prefix: `+${phone.prefix}`
  }
}

const getPhoneCountries = () => {
  phoneCountries.value = PHONE_PREFIX_LIST.map((phone: {prefix: string, isoCode: string; term: string}) => {
    return phoneCountryToItemSelect(phone);
  });
}

const currInstituteName = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "Institut ..."}
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole
  return currentIwr.instituteShortName
});

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {
    return "";
  }
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const closeFormModal = () => {
  emits('afterPatientCreated');
}

const filterGender = () => {
  const ordered = [...genderOptions.value].sort((a, b) => {
    const priority: Record<string, number> = { "MALE": 1, "FEMALE": 2, "NON_BINARY": 3, "NONE": 4 }
    return priority[a] - priority[b]
  });
  return ordered;
}

const checkMailValid = (createPatientRequest : CreatePatientRequest) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (createPatientRequest.mail && !regex.test(createPatientRequest.mail)) {
    createPatientRequest.mail = null;
  }
}

const checkAddressValid = (createPatientRequest : CreatePatientRequest) => {
  if(createPatientRequest.address && !createPatientRequest.address.isoCode){
    createPatientRequest.address.isoCode = IsoCode.LU;
    if(!createPatientRequest.address.postalCode &&
      !createPatientRequest.address.street &&
      !createPatientRequest.address.locality ){
      createPatientRequest.address = null;
    }
  }
}

const checkPhoneValid = (createPatientRequest : CreatePatientRequest) => {
  if(createPatientRequest.phone && !createPatientRequest.phone.phonePrefix){
    createPatientRequest.phone.phonePrefix = IsoCode.LU;
  }
  if(!createPatientRequest.phone.phoneNumber && createPatientRequest.phone.phonePrefix){
      createPatientRequest.phone = null;
  }
}

const checkSerialNumber= (createPatientRequest : CreatePatientRequest) => {
  if(createPatientRequest.serialNumber.includes('_')) {
   createPatientRequest.serialNumber = null;
  }
}

const formatDate = (createPatientRequest : CreatePatientRequest) => {
  if (createPatientRequest.birthdate)
    createPatientRequest.birthdate = format(parse(createPatientRequest.birthdate, DateFormat.FRONT_LONG, new Date()), DateFormat.ISO_SMALL) ;
}


const IMPORT_REGEX = {
  civility: /^(?<civility>Monsieur|Madame|Prof|Mlle|Doctore|Bebe)\b/m,
  name: /^(?:Monsieur|Madame|Prof|Mlle|Doctore|Bebe)?\s*(?<firstname>[A-Z][a-zÀ-ÖØ-öø-ÿ]+(?:[- ][A-Z][a-zÀ-ÖØ-öø-ÿ]+)*)\s+(?<lastname>[A-Z][A-Z -]+(?:-[A-Z]+)*)$/m,
  birthdate: /Date de naissance\s*:\s*(?<birthdate>\d{2}\/\d{2}\/\d{4})(?:\s*;\s*(?<age>\d+))?/i,
  matricule: /N° de matricule\s*:\s*(?<cnsNumber>[^/\n]+)(?:\/\s*(?<cns>.+))?/i,
  address: /Adresse\s*:\s*(?<street>.+?)\s+(?:L\s*[-‑]?\s*)?(?<postal>\d{4,5})\s+(?<city>[A-Za-zÀ-ÖØ-öø-ÿ' -]+)/i,
  phone: /Téléphone\s*:\s*(?<phoneNumber>.+)/i,
  email: /Email\s*:\s*(?<email>.+)/i,
  phoneNumber: /^\+?\d(\s?\d)*$/
};

const extract = (input: string, regex: RegExp, group: string): string | null => {
  const match = input.match(regex);
  return match?.groups?.[group]?.trim() ?? null;
};


const parseClipboard = (input: string) => {
  const civility = extract(input, IMPORT_REGEX.civility, "civility");
  createPatientRequest.value.gender = getGenderFromCivility(civility);

  createPatientRequest.value.firstname = extract(input, IMPORT_REGEX.name, "firstname");
  createPatientRequest.value.lastname = extract(input, IMPORT_REGEX.name, "lastname");

  createPatientRequest.value.birthdate = extract(input, IMPORT_REGEX.birthdate, "birthdate");

  const cns = extract(input, IMPORT_REGEX.matricule, "cnsNumber");
  if (cns) {
    createPatientRequest.value.serialNumber = cns.replaceAll(" ", '');
  }

  createPatientRequest.value.address.street = extract(input, IMPORT_REGEX.address, "street");
  createPatientRequest.value.address.postalCode = extract(input, IMPORT_REGEX.address, "postal");
  createPatientRequest.value.address.locality = extract(input, IMPORT_REGEX.address, "city");

  const phone = extract(input, IMPORT_REGEX.phone, "phoneNumber");
  if (phone) {
    const { phonePrefix, phoneNumber } = extractPhonePrefixAndNumber(phone);

    createPatientRequest.value.phone.phonePrefix = phonePrefix;
    createPatientRequest.value.phone.phoneNumber = phoneNumber;
  }

  createPatientRequest.value.mail = extract(input, IMPORT_REGEX.email, "email");

  if (!createPatientRequest.value.birthdate) {
    toastWarn(toast, {
      summary: t('patient.create.toast.error'),
      detail: t('patient.create.toast.missingBirthdate'),
      life: 5000
    });
    return
  }
  toastSuccess(toast, {
    summary: t('patient.create.toast.success'),
    detail: input,
    life: 5000
  });
};

const extractPhonePrefixAndNumber = (phoneRaw: string) => {
  const Default_Prefix = "LU";
  if (!phoneRaw || !IMPORT_REGEX.phoneNumber.test(phoneRaw)) {
    return {
      phonePrefix: Default_Prefix,
      phoneNumber: "",
    };
  }

  const cleaned = phoneRaw.replace(/[()\s]/g, "").trim();

  if (cleaned.startsWith("+")) {
    const withoutPlus = cleaned.startsWith("+") ? cleaned.substring(1) : cleaned;

    for (const entry of [...PHONE_PREFIX_LIST]) {
      if (withoutPlus.startsWith(entry.prefix)) {
        const nationalNumber = withoutPlus.substring(entry.prefix.length);

        return {
          phonePrefix: entry.isoCode,
          phoneNumber: nationalNumber,
        };
      }
    }

    return {
      phonePrefix: Default_Prefix,
      phoneNumber: withoutPlus,
    };
  } else {
    return {
      phonePrefix: Default_Prefix,
      phoneNumber: cleaned,
    };
  }
};

const getGenderFromCivility = (civility: string | null) => {
  if (civility === "Monsieur") {
    return "MALE";
  }
  if (["Madame", "Mlle"].includes(civility ?? "")) {
    return "FEMALE";
  }
  return "NONE";
};

const pasteAndParseClipboard = async () => {
    const text = await navigator.clipboard.readText();

    if (!text || text.trim().length === 0) {
      toastWarn(toast, {
        summary: t('patient.create.toast.emptyClipboard'),
        detail: t('patient.create.toast.emptyClipboardDetail'),
        life: 5000
      });
      return;
    }

  try {
    parseClipboard(text);
  } catch (e) {
    toastError(toast, {
      summary: t('patient.create.toast.error'),
      detail: "",
      life: 5000
    });
  }
};

const confirmFormModal = async (action: string) => {
  if (currInstituteUuid.value) {
      errorForm.value = false;
      //DEEP COPY
      let request = JSON.parse(JSON.stringify(createPatientRequest.value));

      if (request.serialNumber) {
        request.serialNumber = request.serialNumber.replaceAll(' ', '');
      }
      checkAddressValid(request);
      checkPhoneValid(request);
      checkSerialNumber(request);
      checkMailValid(request);
      formatDate(request);
      
      await patientApi.createPatient({instituteId: currInstituteUuid.value, createPatientRequest: request}).then((result: SearchPatientResponse) => {
        toastSuccess(toast, {
            summary: t('common.toast.success.add'),
            detail:  t('patient.create.message.success.add')
        });

        if (ButtonAction.REDIRECT_CALENDAR === action) {
          emits('redirectCalendar', result);
        } else {
          emits('afterPatientCreated', result);
        }

      }).catch((error: ApiError) => {
        if (!createPatientRequest.value.firstname
        || !createPatientRequest.value.lastname
        || !createPatientRequest.value.gender) {
          errorForm.value = true;
        }

        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });

        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
      });
  }
}

const initialParse = () => {
  if (props.fastPatientCreation && props.clipboardText) {
    try {
      parseClipboard(props.clipboardText);
    } catch (e) {
      toastError(toast, {
        summary: t('patient.create.toast.error'),
        detail: "",
        life: 5000
      });
    }
  }  
}

const activeConfirmButton = () => {
  if (createPatientRequest.value.firstname && createPatientRequest.value.lastname && createPatientRequest.value.gender) {
      errorForm.value = false;
    }
}

watch(
    () => createPatientRequest.value.firstname,
  () => {
    activeConfirmButton();
  }
);

watch(
    () => createPatientRequest.value.lastname,
  () => {
    activeConfirmButton();
  }
);

watch(
    () => createPatientRequest.value.gender,
  () => {
    activeConfirmButton();
  }
);

onMounted(() => {
  getCountries();
  getPhoneCountries();
  initialParse();
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_es_modal_header, {
            header: _unref(t)('patient.create.title', {name: currInstituteName.value})
          }, null, 8, ["header"]),
          (props.fastPatientCreation)
            ? (_openBlock(), _createBlock(_component_buttonGroup, {
                key: 0,
                styles: "pad-m",
                class: "mleft-auto mright-10 rowcenter",
                onClick: pasteAndParseClipboard
              }, {
                default: _withCtx(() => [
                  _cache[14] || (_cache[14] = _createElementVNode("img", {
                    class: "square-14 img-primary",
                    src: _imports_0,
                    alt: 'layout.patient'
                  }, null, -1)),
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.create.form.import'),
                    styles: "font-m",
                    class: "txt-primary mleft-03"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (props.newId.length == 13 || props.fastPatientCreation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('patient.create.form.cns')), 1),
                  _createElementVNode("span", null, _toDisplayString(createPatientRequest.value.birthdate), 1)
                ]),
                _createVNode(_unref(InputText), {
                  disabled: !props.fastPatientCreation,
                  type: "text",
                  size: "small",
                  modelValue: createPatientRequest.value.serialNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createPatientRequest.value.serialNumber) = $event)),
                  class: "w-full"
                }, null, 8, ["disabled", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          (props.newId.length == 8 || props.fastPatientCreation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_unref(t)('patient.create.form.birthdate')), 1),
                    (props.fastPatientCreation)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(InputText), {
                    disabled: !props.fastPatientCreation,
                    type: "text",
                    size: "small",
                    modelValue: createPatientRequest.value.birthdate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createPatientRequest.value.birthdate) = $event)),
                    class: "w-full"
                  }, null, 8, ["disabled", "modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_unref(t)('patient.create.form.lastname')), 1),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: createPatientRequest.value.lastname,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createPatientRequest.value.lastname) = $event)),
                class: "w-full",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            (!createPatientRequest.value.lastname && errorForm.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  class: "mleft-90 mtop-02",
                  severity: "error",
                  size: "small",
                  variant: "simple"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('error.REQUIRED')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(t)('patient.create.form.firstname')), 1),
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: createPatientRequest.value.firstname,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createPatientRequest.value.firstname) = $event)),
                class: "w-full",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            (!createPatientRequest.value.firstname && errorForm.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  class: "mleft-90 mtop-02",
                  severity: "error",
                  size: "small",
                  variant: "simple"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('error.REQUIRED')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_unref(t)('patient.create.form.gender')), 1),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterGender(), (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: option,
                    class: "flex items-center"
                  }, [
                    _createVNode(_unref(RadioButton), {
                      modelValue: createPatientRequest.value.gender,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createPatientRequest.value.gender) = $event)),
                      inputId: `gender-${option}`,
                      value: option,
                      class: "mright-05",
                      size: "small",
                      required: ""
                    }, null, 8, ["modelValue", "inputId", "value"]),
                    _createElementVNode("label", {
                      class: "main-m font-m",
                      for: `gender-${option}`
                    }, _toDisplayString(_unref(t)(`common.gender.${option}`)), 9, _hoisted_27)
                  ]))
                }), 128))
              ])
            ]),
            (!createPatientRequest.value.gender && errorForm.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  class: "mleft-90 mtop-02",
                  severity: "error",
                  size: "small",
                  variant: "simple"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('error.REQUIRED')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('patient.create.form.favoritePhone')), 1)
            ]),
            _createVNode(EsSelectCountry, {
              selectedData: phoneCountries.value.find(country => country.id === createPatientRequest.value.phone.phonePrefix),
              countries: phoneCountries.value,
              "show-prefix": true,
              default: true,
              onChangeSelect: _cache[5] || (_cache[5] = currentCountry => createPatientRequest.value.phone.phonePrefix = currentCountry)
            }, null, 8, ["selectedData", "countries"]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createPatientRequest.value.phone.phoneNumber,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createPatientRequest.value.phone.phoneNumber) = $event)),
              class: "w-full mleft-02"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('patient.create.form.mobile')), 1)
            ]),
            _createVNode(_unref(Checkbox), {
              modelValue: createPatientRequest.value.phone.mobile,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createPatientRequest.value.phone.mobile) = $event)),
              binary: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('patient.create.form.mail')), 1)
            ]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createPatientRequest.value.mail,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createPatientRequest.value.mail) = $event)),
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("h4", _hoisted_36, _toDisplayString(_unref(t)('patient.create.form.address')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)('patient.create.form.street')), 1)
            ]),
            _createVNode(_unref(InputText), {
              class: "w-full",
              type: "text",
              size: "small",
              modelValue: createPatientRequest.value.address.street,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createPatientRequest.value.address.street) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('patient.create.form.postalCode')), 1)
            ]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createPatientRequest.value.address.postalCode,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createPatientRequest.value.address.postalCode) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('patient.create.form.locality')), 1)
            ]),
            _createVNode(_unref(InputText), {
              class: "w-full",
              type: "text",
              size: "small",
              modelValue: createPatientRequest.value.address.locality,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createPatientRequest.value.address.locality) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('patient.create.form.country')), 1)
            ]),
            _createVNode(EsSelectCountry, {
              modelValue: createPatientRequest.value.address.isoCode,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((createPatientRequest.value.address.isoCode) = $event)),
              countries: countries.value,
              default: true,
              onChangeSelect: _cache[13] || (_cache[13] = currentCountry => createPatientRequest.value.address.isoCode = currentCountry)
            }, null, 8, ["modelValue", "countries"])
          ])
        ]),
        _createVNode(_component_es_modal_footer, {
          onModalCancel: closeFormModal,
          "item-button-group": itemButtonGroup.value,
          confirmDisabled: errorForm.value
        }, null, 8, ["item-button-group", "confirmDisabled"])
      ], 512)
    ])
  ]))
}
}

})